import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useRef, useEffect, useState, forwardRef } from 'react';
import { Spacings } from '../../../../styleConstants';
import { getOffsetTop } from '../sections';

const Wrapper = styled.div`
  overflow: hidden;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 240px;
  line-height: 297px;
  white-space: nowrap;
  display: inline-block;
  letter-spacing: -${Spacings.SPACING_2B};
  color: ${({ $color }) => $color};
`;

const SectionName = forwardRef(({ title, color }, ref) => {
  const titleRef = ref;
  const [left, setLeft] = useState(0);
  const [opacity, setOpacity] = useState(0);
  const offsetFromTop = useRef(0);
  const movementSpeed = useRef(0);
  const leftBuffer = useRef(0);
  const rightBuffer = useRef(0);
  const elementWidth = useRef(0);
  const extrapolatedWidth = useRef(0);

  useEffect(() => {
    const { width } = titleRef.current.getBoundingClientRect();
    elementWidth.current = width;
    extrapolatedWidth.current = window.innerWidth + width / 2;
    leftBuffer.current = -width - 100;
    rightBuffer.current = window.innerWidth + 100;
    offsetFromTop.current = getOffsetTop(titleRef.current);
    const speed = window.innerWidth / window.innerHeight;
    movementSpeed.current = speed;
    setLeft((window.innerWidth + offsetFromTop.current) * speed);
  }, [titleRef]);

  useEffect(() => {
    setOpacity(
      parseFloat(
        Math.sin(
          ((left + elementWidth.current / 2) * Math.PI) /
            extrapolatedWidth.current
        ).toFixed(2)
      ) * 0.7
    );
  }, [left]);

  useEffect(() => {
    const onScroll = () => {
      const position =
        (offsetFromTop.current - document.documentElement.scrollTop) *
        movementSpeed.current;
      if (position > leftBuffer.current && position < rightBuffer.current) {
        setLeft(position);
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <Wrapper>
      <Title
        ref={titleRef}
        $color={color}
        style={{
          transform: `translate3d(${left}px, 0px, 0px)`,
          opacity
        }}
      >
        {title}
      </Title>
    </Wrapper>
  );
});

SectionName.displayName = 'SectionName';

SectionName.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export default SectionName;
